export default function isQuotaExceededError(err) {
    if (err?.name === 'AbortError' && err.message.includes('QuotaExceededError')) return true;
    if (err.message?.includes('database or disk is full')) return true; // sqllite errors look like this
    return false;
}
